import Cookie from 'js-cookie'
export default {
    state: {
        //侧边栏
        isCollapse: false,
        //面包屑
        tabname:'首页',

        // tabsList: [
        //     {
        //         path: "/home/main",
        //         name: "main",
        //         label: "首页",
        //         icon: "s-home",
        //         url: "Main.vue",
        //     },
        // ],

        menu: []
    },
    mutations: {
        //侧边栏收缩
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        //更新面包屑
        selectMenu(state, val) {
            state.name=val.label
            // if (val.name !== "home") {
            //     const index = state.tabsList.findIndex(item => item.name === val.name)
            //     if (index === -1) {
            //         state.tabsList.push(val)
            //     }
            // }
        },
        //还原面包屑
        deleteMenu(state) {
            state.name='首页'
            // state.tabsList = [
            //     {
            //         path: "/home/main",
            //         name: "main",
            //         label: "首页",
            //         icon: "s-home",
            //         url: "Main.vue",
            //     },
            // ]
        },

        //menu设置
        setMenu(state, val) {
            state.menu = val
            //if (time) {
                //Cookie.set('menu', JSON.stringify(val), { expires: time })
            //} else {
                Cookie.set('menu', JSON.stringify(val))
            //}

        },
        //动态注册路由
        addMenu(state, router) {
            if (!Cookie.get('menu')) return
            const menu = JSON.parse(Cookie.get('menu'))
            state.menu = menu
            const menuArray = []

            menu.forEach(item => {
                if (item.children) {
                    item.children = item.children.map(item => {
                        item.component = () => import(`@/pages/${item.url}`)
                        return item
                    })
                    menuArray.push(...item.children)
                } else {
                    item.component = () => import(`@/pages/${item.url}`)
                    menuArray.push(item)
                }
            })
            menuArray.forEach(item => {
                router.addRoute('home', item)
            })

        }

    }
}